import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["id"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "tooltip-arrow",
  "data-popper-arrow": ""
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "prose my-1 max-w-none text-justify sm:prose-lg",
      innerHTML: _ctx.markdown,
      onMouseup: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.explainTerm && _ctx.explainTerm(...args)))
    }, null, 40, _hoisted_1),
    (_ctx.tooltip != 'None')
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          id: _ctx.id,
          class: "tooltip absolute z-10 inline-block max-w-lg rounded-lg bg-gray-900 px-3 py-2 text-sm font-medium text-white opacity-100 shadow-sm transition-opacity duration-300 dark:bg-gray-700"
        }, [
          _createTextVNode(_toDisplayString(_ctx.tooltip) + " ", 1),
          _hoisted_3
        ], 8, _hoisted_2))
      : _createCommentVNode("", true)
  ], 64))
}